module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"powerhour":"パワーアワー","monday":"月曜日","tuesday":"火曜日","wednesday":"水曜日","thursday":"木曜日","friday":"金曜日","saturday":"土曜日","sunday":"日曜日","actual_value":"実数値","percent_daily":"% 日別","percent_weekly":"% 週別","powerHourTooltip1":"店舗の混雑状況を表示します。色の濃い時間帯が客数が集中しているのが「パワーアワー」です。「実数値」は実際の来店客数を表示するほか、「週間％」は1週間を１００％、「日間％」は1日を１００％としたときの来店客数のパーセンテージを表示します。","unit":"人"}}')
  delete Component.options._Ctor
}
